import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import languageEN from "./locate/en/translate.json";
import languageTR from "./locate/tr/translate.json";

i18n
  //.use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: languageEN,
      tr: languageTR,
    },
    /* default language when load the website in browser */
    lng: null, // if set null, browser language load
    /* When react i18next not finding any language to as default in borwser */
    fallbackLng: "en",
    /* debugger For Development environment */
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
      nsMode: "default",
      useSuspense: false,
    },
  });

export default i18n;
